import React, { Fragment } from "react";
import { Col, Row } from "antd";
import DiscussionPlayer from "./DiscussionPlayer";
import ScrollToTop from "../../../common/cards/ScrollToTop";
import { SideBar } from "../../../common/leftsidebar";
import { PROFILE } from "../../../Store/Features/ProfileSlice";
import { useSelector } from "react-redux";
import { ROLES } from "../../../Config/helpers/constants";

const Profile = () => {
  const id = useSelector(PROFILE);

  return (
    <Fragment>
      <ScrollToTop />
      <Row justify="center" gutter={[20, 0]} className="rowPadding">
        <SideBar current={ROLES.player} />
        <Col
          xs={{ span: 24, order: 3 }}
          sm={{ span: 24, order: 3 }}
          md={{ span: 24, order: 3 }}
          lg={{ span: 14, order: 2 }}>
          {id?._id ? <DiscussionPlayer /> : null}
        </Col>
      </Row>
    </Fragment>
  );
};

export default Profile;
